import { useLayoutEffect } from "preact/hooks";

export const useBodyStyle = (className: string) => {
    useLayoutEffect(() => {
        const old = document.body.className;
        document.body.className = (!old ? "" : (old + " ")) + className;
        return () => {
            document.body.className = old;
        }
    }, [className]);
};
